module.exports = __webpack_public_path__ + "img/QuickEntrance_rlqd.d708996f.svg";